import { Injectable } from '@angular/core';

/** Holds the reference to the LAO tab opened via window.open so logout can close it. */
@Injectable({ providedIn: 'root' })
export class LaoWindowService {
  private laoWindow: Window | null = null;

  set(win: Window | null): void {
    this.laoWindow = win;
  }

  close(): void {
    if (this.laoWindow && !this.laoWindow.closed) {
      this.laoWindow.close();
    }
    this.laoWindow = null;
  }
}
